import { ReactNode } from "react";
import Circle from "../components/Circle";
import { CircularProgress } from "@mui/material";

export const FileStatus = [
  "uploading",
  "uploaded",
  "empty",
  "approved",
  "rejected",
];

export const FileStatusDisplay: Record<string, ReactNode> = {
  uploading: <CircularProgress size="1em" />,
  uploaded: "⚪️",
  empty: null,
  approved: "🟢",
  rejected: "🔴",
};

export const ProgressStatusDisplay: Record<string, ReactNode> = {
  approved: <Circle type="green" />,
  rejected: <Circle type="red" />,
  empty: <Circle type="blank" />,
};
